import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
//import AuthenticationHandler, { AuthenticationHandlerRenderProps } from '@virtus/common/auth/AuthenticationHandler';
import AuthenticationHandlerAdmin, { AuthenticationHandlerRenderProps } from './AuthenticationHandlerAdmin';
import { authSelectors } from '@virtus/common/auth/reducer';
import { VirtusTheme } from '@virtus/components';
import { LoadingIconSizes } from '@virtus/components/LoadingIcon/LoadingIcon';
import React, { Suspense, useState, useCallback, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { mutateAsync, querySelectors } from 'redux-query';
import UseSignalR, { useSignalR } from 'src/comps/SignalR/UseSignalR';
import AdminUserProfile, { ReduxProps as AdminUserProfileProps } from 'src/comps/UserProfile/UserProfile';
import config from 'src/config';
import configureHeader from 'src/config/headerConfig';
import DropDownControlCodeTableRow from 'src/formcontrols/DropDown/DropDownControlCodeTableRow';
import CheckBoxControlRow from 'src/formcontrols/CheckBoxControl/CheckBoxControlRow';
import Loading from 'src/formcontrols/Loading';
import { EditModal } from 'src/formcontrols/Modals/EditModal/EditModal';
import { appResponseSelector, getUserProfile, saveUserProfile } from 'src/queries/userProfile';
import { dateRangeSelectorActions } from 'src/reducers/dateRangeSelector';
import { inspectorActions } from 'src/reducers/inspector';
import { RootState } from 'src/reducers/rootReducer';
import { routes } from 'src/routes';
import WidgetContainer from 'src/WidgetContainer/WidgetContainer';
import styled from 'styled-components';
import { GetLocalStateProfile } from 'src/comps/UserProfile/UserProfile';
import { writeAIEvent } from 'src/utils/AppInsight';
import SignalRConnector from 'src/coreservices/SignalRConnector';
import { logoutAad } from '@virtus/common/auth/aadWrapper';
import { compose } from 'redux';

const NotFound = React.lazy(() => import('@virtus/components/page/NotFound'));
const Header = React.lazy(() => import('@virtus/components/page/Header'));
const DetailsLogInspector = React.lazy(() => import('src/comps/Inspector/DetailsLogInspector'));
const Home = React.lazy(() => import('src/pages/Home'));
const Logs = React.lazy(() => import('src/pages/Logs'));
const Tools = React.lazy(() => import('src/pages/Tools'));
const EventLog = React.lazy(() => import('src/pages/EventLog'));
const ErrorLog = React.lazy(() => import('src/pages/ErrorLog'));
const SignalRLog = React.lazy(() => import('src/pages/SignalRLog'));
const UserLog = React.lazy(() => import('src/pages/UserLog'));
const AddError = React.lazy(() => import('src/pages/AddError'));
const Application = React.lazy(() => import('src/pages/ApplicationDetails'));
const ApplicationInsight = React.lazy(() => import('src/pages/AppInsightDetails'));
const DevOpsOutput = React.lazy(() => import('src/pages/DevOpsOutput'));
const UserLogPage = React.lazy(() => import('src/pages/UserLogPage'));
const TelemetryLog = React.lazy(() => import('src/pages/TelemetryLog'));
const ReportActivityLog = React.lazy(() => import('src/pages/ReportActivityLog'));

const headerConfiguration = configureHeader(routes);
interface ReduxProps {
  readonly authStatus: any;
  readonly authError: any;
  readonly user: any;
  isLoading: boolean;
  response: string;
  //  id_token?: string;
}

interface ReduxDispatch {
  closeInspectors: () => void;
  clearDateRanges: () => void;
  closeTimeFrame: () => void;
  saveUserProfile: any;
  getUserProfile: any;
}
interface IProps {
  isOpenPopup: boolean;
  userName: string;
  saveUserProfile: (
    userName: string,
    numberOfGridRow: number,
    defaultSearchTimeSpan: string,
    defaultUseSignalR: boolean,
    Id: string,
  ) => void;
  getUserProfile: (userName: string) => void;
  router: any; // Injected by withRouter HOC
}
type Props = ReduxProps & ReduxDispatch & IProps;
/** Theme, Header and Routing */

// Static values moved outside component
let stNumberOfGridRow: string;
let stDefaultSearchTimeSpan: string;
let stUserName: string;
let stDefaultUseSignalR: boolean;
let stUserId: string;

export const getDetails = () => {
  return {
    numberOfGridRow: stNumberOfGridRow,
    defaultSearchTimeSpan: stDefaultSearchTimeSpan,
    userName: stUserName,
    defaultUseSignalR: stDefaultUseSignalR,
    Id: stUserId,
  };
};

const logoutUser = () => {
  //logout();
  logoutAad();
};

const App: React.FC<Props> = props => {
  // Router hooks - must be at top level
  const location = useLocation();
  const navigate = useNavigate();

  // Convert class state to useState hooks
  const [openUserProfile, setOpenUserProfile] = useState(false);
  const [numberOfGridRow, setNumberOfGridRow] = useState(config.defaultProfile.DefaultGridRows.toString());
  const [defaultSearchTimeSpan, setDefaultSearchTimeSpan] = useState(config.defaultProfile.DefaultTimeRange);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultUseSignalR, setDefaultUseSignalR] = useState(config.defaultProfile.DefaultUseSignalR);
  // const [isOpenSignalRDetail, setIsOpenSignalRDetail] = useState(false);
  const [onSaveUseSignalR, setOnSaveUseSignalR] = useState(false);
  const [userObj, setUserObj] = useState<any>(null);

  // Track the previous pathname so we can clear date ranges only when navigating
  // AWAY from log pages (after the old page has unmounted).
  // This prevents the outgoing page's connectRequest HOC from reacting
  // to the date reset and firing a spurious API call.
  const prevPathnameRef = useRef(location.pathname);

  useEffect(() => {
    const prevPath = prevPathnameRef.current;
    const currentPath = location.pathname;

    if (prevPath !== currentPath) {
      prevPathnameRef.current = currentPath;

      // Only clear date ranges when navigating away FROM a log page
      // to a non-log page (like Home, Tools, etc).
      // Don't clear when navigating TO log pages or BETWEEN log pages,
      // as each log page should maintain the current date range.
      const wasOnLogPage = prevPath.startsWith('/Logs/');
      const isOnLogPage = currentPath.startsWith('/Logs/');

      if (wasOnLogPage && !isOnLogPage) {
        props.clearDateRanges();
      }
    }
  }, [location.pathname, props]);

  const numberOfGridRows = [
    { numberOfGridRow: 10 },
    { numberOfGridRow: 25 },
    { numberOfGridRow: 50 },
    { numberOfGridRow: 100 },
    { numberOfGridRow: 200 },
  ];

  const defaultSearchTimeSpans = [
    { defaultSearchTimeSpanValue: 'P30M', defaultSearchTimeSpan: 'Past 30 Minutes' },
    { defaultSearchTimeSpanValue: 'P1H', defaultSearchTimeSpan: 'Past Hour' },
    { defaultSearchTimeSpanValue: 'P4H', defaultSearchTimeSpan: 'Past 4 Hours' },
    { defaultSearchTimeSpanValue: 'P6H', defaultSearchTimeSpan: 'Past 6 Hours' },
    { defaultSearchTimeSpanValue: 'P12H', defaultSearchTimeSpan: 'Past 12 Hours' },
    { defaultSearchTimeSpanValue: 'P24H', defaultSearchTimeSpan: 'Past 24 Hours' },
    { defaultSearchTimeSpanValue: 'P3D', defaultSearchTimeSpan: 'Past 3 Days' },
    { defaultSearchTimeSpanValue: 'P7D', defaultSearchTimeSpan: 'Past 7 Days' },
    { defaultSearchTimeSpanValue: 'P30D', defaultSearchTimeSpan: 'Past 30 Days' },
  ];

  // Convert componentDidMount to useEffect
  // Only fetch user profile after authentication is confirmed (userObj is set)
  useEffect(() => {
    const initialize = async () => {
      if (userObj?.idTokenClaims?.email) {
        await props.getUserProfile(userObj.idTokenClaims.email);
        await connectSignalR();
      }
    };
    initialize();
  }, [userObj]);

  // Update userObj when authenticated user changes
  useEffect(() => {
    if (props.user && props.user !== userObj) {
      setUserObj(props.user);
    }
  }, [props.user, userObj]);

  const connectSignalR = async () => {
    const userProfile = GetLocalStateProfile();
    if (userProfile.DefaultUseSignalR) {
      const signalRConnector = new SignalRConnector({ isUseSignalR: false });
      await signalRConnector.connectToSignalR();
      signalRConnector.updateUseSignalR(true);
      const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
      if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
        imgSignalR[0].style.display = 'block';
      }
    }
  };

  const trackAiEvent = (path: string | undefined) => {
    let pageName = path || '';
    do {
      pageName = pageName.replace('/', '');
    } while (pageName.indexOf('/') > -1);
    writeAIEvent(`Transited to page - ${pageName}`);
  };

  const logoutFromApp = () => {
    writeAIEvent(`${props.userName} logged out from Virtus Admin Application.`);
  };

  const onRouteChange = useCallback(
    (path?: string) => {
      setOpenUserProfile(false);
      // setIsOpenSignalRDetail(false);
      props.closeInspectors();
      props.closeTimeFrame();

      trackAiEvent(path);

      if (path) {
        navigate(path);
      }
    },
    [props, navigate],
  );

  const openUserProfilePopup = async () => {
    setOpenUserProfile(true);
    const userProfileDetails = GetLocalStateProfile();
    writeAIEvent(`Opened User profile modal window.`);
    setNumberOfGridRow(userProfileDetails.DefaultGridRows);
    setDefaultSearchTimeSpan(userProfileDetails.DefaultTimeRange);
    setDefaultUseSignalR(userProfileDetails.DefaultUseSignalR);
  };

  const saveToStorage = (userProfile: any) => {
    if (userProfile !== undefined) localStorage.setItem('USER_PROFILE_LOCAL', JSON.stringify(userProfile));
  };

  const handleSaveUserProfile = async () => {
    stDefaultSearchTimeSpan = defaultSearchTimeSpan;
    stNumberOfGridRow = numberOfGridRow;
    stUserName = props.userName;
    stDefaultUseSignalR = defaultUseSignalR;
    stUserId = userObj?.localAccountId;
    setIsLoading(true);
    saveToStorage({
      UserName: userObj?.idTokenClaims?.email,
      DefaultGridRows: numberOfGridRow,
      DefaultTimeRange: defaultSearchTimeSpan,
      DefaultUseSignalR: defaultUseSignalR,
      Id: userObj?.localAccountId,
    });
    const signalRConnector = new SignalRConnector({ isUseSignalR: false });
    if (!defaultUseSignalR) {
      await signalRConnector.disconnectSignalR();
      signalRConnector.updateUseSignalR(false);
      const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
      if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
        imgSignalR[0].style.display = 'none';
      }
    }
    await props.saveUserProfile(
      userObj?.idTokenClaims?.email,
      numberOfGridRow,
      defaultSearchTimeSpan,
      defaultUseSignalR,
      userObj?.localAccountId,
    );
    await props.getUserProfile(userObj?.idTokenClaims?.email);
    setIsLoading(false);
    setOpenUserProfile(false);
    setOnSaveUseSignalR(true);

    if (defaultUseSignalR) {
      await signalRConnector.connectToSignalR();
      signalRConnector.updateUseSignalR(true);
      const imgSignalR = document.getElementsByClassName('signalRClass') as HTMLCollectionOf<HTMLElement>;
      if (imgSignalR[0] !== null && imgSignalR[0] !== undefined) {
        imgSignalR[0].style.display = 'block';
      }
    }
  };

  const updateUseSignalR = async () => {
    setOnSaveUseSignalR(false);
  };

  const onClose = async () => {
    writeAIEvent(`Closed User profile modal window.`);
    setOpenUserProfile(false);
  };

  const getDefaultRoute = (pathName: string) => {
    let defaultPath: string;
    switch (pathName) {
      case '/': {
        defaultPath = '/Home';
        break;
      }
      default: {
        defaultPath = pathName;
        break;
      }
    }
    return defaultPath;
  };

  const changeHandler = async (event: any) => {
    const { name, value } = event.target;
    if (name === 'numberOfGridRow') {
      setNumberOfGridRow(value);
    } else if (name === 'defaultSearchTimeSpan') {
      setDefaultSearchTimeSpan(value);
    }
  };

  const changeCheck = async (event: any) => {
    setDefaultUseSignalR(event.target.checked);
  };
  // {
  //     let result = "useIDP" in config;
  //     if(result && config.useIDP) {
  //       this.config = config.idp;
  //     } else {
  //       this.config = config.b2c;
  //     }
  // }
  return (
    <Suspense fallback={<div />}>
      <VirtusTheme>
        {/* <GlobalHeaderStyles /> */}
        <AuthenticationHandlerAdmin
          config={config.aad}
          render={({ isAuthenticated, login, logout, user, isValidUser, error }: AuthenticationHandlerRenderProps) => {
            if (error) {
              logoutUser();
              return <></>;
            }
            if (!isValidUser.IsValidUser) {
              logoutUser();
              return <></>;
            }

            {
              /* <AuthenticationHandlerAdmin
            config={this.config}
            render={({ isAuthenticated, login, logout, user, emailAddress }: AuthenticationHandlerRenderProps) => {
              this.userObj = emailAddress; */
            }
            if (!isAuthenticated && props.authStatus.status === 'initialized' && props.authError === undefined) {
              // Show Unauthorzed user message
              return (
                <WidgetContainer
                  title="Unauthorized user"
                  onRemove={widgetRemove}
                  subtitle={config.unauthorizedTextMessage}
                />
              );
            } else {
              return (
                <AppWrapper>
                  <Header
                    {...headerConfiguration}
                    isLoggedIn={isAuthenticated}
                    onRouteChange={onRouteChange}
                    onLogin={login}
                    path={getDefaultRoute(location.pathname)}
                    topRightButtonText={user ? user.name : ''}
                    appColor="#000000"
                    topRightMenuItems={[
                      ...[
                        {
                          text: '',

                          onClick: () => console.info('Use SignalR'),
                          component: (
                            <UseSignalR
                              switched={useSignalR}
                              position="menu"
                              onSaveUseSignalR={onSaveUseSignalR}
                              updateUseSignalR={updateUseSignalR}
                            />
                          ),
                          isIdleOnClick: true,
                        },
                        { text: 'Profile', onClick: openUserProfilePopup },
                      ],
                      ...headerConfiguration.topRightMenuItems,
                      ...[
                        {
                          text: 'Logout',
                          onClick: () => {
                            logoutFromApp();
                            logout();
                          },
                        },
                      ],
                    ]}
                    misc={undefined}
                    // misc={<UseSignalR switched={false} position="app" isOpenSignalRDetail={isOpenSignalRDetail} />}
                  />
                  {isAuthenticated && (
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/Home" element={<Home />} />
                      <Route path="/Logs" element={<Logs />} />
                      <Route path="/Logs/ErrorLog" element={<ErrorLog />} />
                      <Route path="/Logs/EventLog" element={<EventLog />} />
                      <Route path="/Logs/SignalRLog" element={<SignalRLog />} />
                      <Route path="/Logs/UserLog" element={<UserLog />} />
                      <Route path="/Logs/UserLogPage" element={<UserLogPage />} />
                      <Route path="/Logs/TelemetryLog" element={<TelemetryLog />} />
                      <Route path="/Logs/ReportActivityLog" element={<ReportActivityLog />} />
                      <Route path="/Tools" element={<Tools />} />
                      <Route path="/Tools/AddError" element={<AddError />} />
                      <Route path="/Tools/Application" element={<Application />} />
                      <Route path="/Tools/DevOpsOutput" element={<DevOpsOutput />} />
                      <Route path="/AppInsightDetails" element={<ApplicationInsight />} />
                      <Route path="*" element={<NotFound appName="Virtus Admin" />} />
                    </Routes>
                  )}
                  {isAuthenticated && (
                    <>
                      <AdminUserProfile>
                        {({ isLoading, userProfile }: AdminUserProfileProps) => {
                          if (isLoading) {
                            return <Loading loading={isLoading} type="dark" size={LoadingIconSizes.large} full />;
                          }
                          if (isAuthenticated && userProfile !== undefined) {
                            saveToStorage(userProfile);
                          }
                          return null;
                        }}
                      </AdminUserProfile>
                    </>
                  )}
                  <DetailsLogInspector />

                  <EditModal
                    isLoading={false}
                    isModalOpen={openUserProfile}
                    modalHeader="User Profile"
                    onCloseModal={onClose}
                    onSave={handleSaveUserProfile}
                  >
                    <Loading loading={isLoading} type="light" style={{ position: 'absolute', left: '50%' }} />

                    <table>
                      <tbody>
                        <DropDownControlCodeTableRow
                          label="Number of Grid Rows"
                          name="numberOfGridRow"
                          value={numberOfGridRow}
                          valueField="numberOfGridRow"
                          displayField="numberOfGridRow"
                          data={numberOfGridRows}
                          selectOption="(None)"
                          isRequired={true}
                          isReadonly={false}
                          onChange={changeHandler}
                        />
                        <DropDownControlCodeTableRow
                          label="Default Search Time Span"
                          name="defaultSearchTimeSpan"
                          value={defaultSearchTimeSpan}
                          valueField="defaultSearchTimeSpanValue"
                          displayField="defaultSearchTimeSpan"
                          data={defaultSearchTimeSpans}
                          selectOption="(None)"
                          isRequired={true}
                          isReadonly={false}
                          onChange={changeHandler}
                        />
                        <CheckBoxControlRow
                          label="Use SignalR by default"
                          isRequired={false}
                          isReadonly={false}
                          value={Boolean(defaultUseSignalR)}
                          name="defaultUseSignalR"
                          onChange={changeCheck}
                        />
                      </tbody>
                    </table>
                  </EditModal>
                </AppWrapper>
              );
            }
          }}
          {...({} as any)} // Bypass type checking temporarily
        />
      </VirtusTheme>
    </Suspense>
  );
};

const widgetRemove = () => {
  return;
};

const mapStateToProps = (state: RootState): ReduxProps => {
  const { userName, numberOfGridRow, defaultSearchTimeSpan, defaultUseSignalR, Id } = getDetails();
  return {
    authStatus: authSelectors.getStatus(state),
    authError: authSelectors.loginError(state),
    user: authSelectors.getUser(state),
    //  id_token: authSelectors.getAccessToken(state),
    response: appResponseSelector(state),
    isLoading: querySelectors.isPending(
      state.queries,
      saveUserProfile(userName, numberOfGridRow, defaultSearchTimeSpan, defaultUseSignalR, Id),
    ),
  };
};

const mapDispatchToProps: ReduxDispatch = {
  closeInspectors: inspectorActions.close,
  clearDateRanges: dateRangeSelectorActions.clearDateRange,
  closeTimeFrame: dateRangeSelectorActions.closeTimeFrame,
  saveUserProfile: (
    userName: string,
    numberofGridRow: string,
    defaultSearchTimeSpan: string,
    defaultUseSignalR: boolean,
    Id: string,
  ) => mutateAsync(saveUserProfile(userName, numberofGridRow, defaultSearchTimeSpan, defaultUseSignalR, Id)),
  getUserProfile: (userName: string) => mutateAsync(getUserProfile(userName)),
};

export default compose<any>(connect(mapStateToProps, mapDispatchToProps)(App));

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  max-width: 100%;
  overflow: hidden;
`;
